export const DEEP_VIEW_LINEAGE_KEY_BY_COLUMN: Record<string, string> = {
  clicks: "clicks",
  reg: "registrations",
  ftd: "ftd",
  qftd: "qftd",
  // Business Leader Dashboard → Brand Performance
  cpa_income_usd: "cpa_income",
  revshare_income_usd: "revshare_income",
  total_income_usd: "total_income",
  // Biz Development Dashboard → Performance
  cpa_income_org_currency: "cpa_income",
  revshare_income_org_currency: "revshare_income",
  totalincome_org_currency: "total_income",
  netrev: "net_revenue",
};

export const getDeepViewFieldKey = (columnKey?: string) =>
  columnKey
    ? (DEEP_VIEW_LINEAGE_KEY_BY_COLUMN[columnKey] ?? columnKey)
    : undefined;

/** Entry from `deepViewData.lineage` for the clicked column. */
export const getDeepViewLineageEntry = (
  deepViewData: any,
  columnKey?: string,
) => {
  const fieldKey = getDeepViewFieldKey(columnKey);
  return fieldKey ? deepViewData?.lineage?.[fieldKey] : undefined;
};

/**
 * `ba_prefix` identifies the Business Adviser treatment. Gap-rule fields are
 * not a single value — the rule name is appended, e.g. "gap_rule_ilf".
 */
export const isGapRuleBaPrefix = (baPrefix?: string) =>
  String(baPrefix ?? "").includes("gap_rule");

/** Entry from `deepViewData.values` for the clicked column. */
export const getDeepViewValuesEntry = (
  deepViewData: any,
  columnKey?: string,
) => {
  const fieldKey = getDeepViewFieldKey(columnKey);
  return fieldKey ? deepViewData?.values?.[fieldKey] : undefined;
};
